import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
interface UseIntersectionObserverProps {
  onInView?: () => void;
  onOutOfView?: () => void;
  isReadyToFetch?: () => boolean;
  threshold?: number;
}
export const useIntersectionObserver = t0 => {
  const $ = _c(13);
  const {
    onInView,
    onOutOfView,
    isReadyToFetch,
    threshold: t1
  } = t0;
  const threshold = t1 === undefined ? 0.8 : t1;
  let t2;
  if ($[0] !== threshold) {
    t2 = {
      threshold
    };
    $[0] = threshold;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [ref, inView] = useInView(t2);
  let t3;
  if ($[2] !== isReadyToFetch) {
    t3 = isReadyToFetch?.() || !isReadyToFetch;
    $[2] = isReadyToFetch;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isFetchReady = t3;
  let t4;
  if ($[4] !== inView || $[5] !== isFetchReady || $[6] !== onInView || $[7] !== onOutOfView) {
    t4 = () => {
      if (inView && onInView && isFetchReady) {
        onInView();
      } else {
        if (!inView && onOutOfView && isFetchReady) {
          onOutOfView();
        }
      }
    };
    $[4] = inView;
    $[5] = isFetchReady;
    $[6] = onInView;
    $[7] = onOutOfView;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== inView) {
    t5 = [inView];
    $[9] = inView;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== ref) {
    t6 = {
      observerRef: ref
    };
    $[11] = ref;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};